import { useSyncExternalStore } from 'react'

/**
 * Whether a CSS media query matches right now, and again whenever it changes.
 *
 * Reads `window.matchMedia` directly (no state copy), so a component that
 * switches on it is correct on its first render and across a resize.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    onChange => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches
  )
}

/**
 * Tailwind's `sm` breakpoint, the one `Sheet` goes full screen below (`w-full
 * sm:max-w-[480px]`). A layout that switches with the sheet uses this query, so
 * the page and its sheet agree on what a phone is. Written as `min-width`
 * because that is the form that matches in the test stub's "desktop" default.
 */
export const SM_UP_QUERY = '(min-width: 640px)'
